import React from 'react'
import BaseComponent from './BaseComponent'
import { NavLink } from 'react-router-dom'
import Footer from './Footer'
import _ from 'lodash'
import SideNav from './SideNav'

export default class OfferPage extends BaseComponent {

  render() {
  	let selectedProducts, selectedCategory = null
    let page = null

    page = _.filter(this.props.data.pages, { slug: this.props.location.pathname })[0]

    if (this.props.match.params.name) {
      selectedCategory = _.filter(this.props.data.categories, { slug: this.props.match.params.name })[0]
    }

  	if (this.props.match.params.name === "promocje") {
      selectedProducts = _.filter(this.props.data.products, (item) => {
        if (parseInt(item.offer_percentage, 10) > 0) {
          return item
        }
      })
  	} else if(this.props.match.params.name) {
      if(selectedCategory) {
        selectedProducts = _.filter(this.props.data.products, { category: selectedCategory.id })
      } else {
        selectedProducts = []
      }
    } else {
      selectedProducts = this.props.data.products
    }

  	let products = []

    if (this.props.match.params.name) {
      products = selectedProducts.map((item, i) => {
        return (
          <li key={ i } className="product-item">
            <div className="image">
              <img src={ item.image } alt={ item.title }/>
            </div>
            <h4>{ item.title }</h4>
            <p dangerouslySetInnerHTML={{ __html: item.head }}></p>
            <NavLink to={ "/produkt/" + item.slug } className="btn">Sprawdź</NavLink>
          </li>
        )
      })
    } else {
      products = this.props.data.categories.map((item, i) => {
        let items = _.filter(selectedProducts, { category: item.id }).map((prod, j) => {
          return (
            <li key={ j } className="product-item">
              <div className="image">
                <img src={ prod.image } alt={ prod.title }/>
              </div>
              <h4>{ prod.title }</h4>
              <p dangerouslySetInnerHTML={{ __html: prod.head }}></p>
              <NavLink to={ "/produkt/" + prod.slug } className="btn">Sprawdź</NavLink>
            </li>
          )
        })
        return (
          <li key={ i }>
            <h2 dangerouslySetInnerHTML={{ __html: this.addColor(item.title) }}></h2>
            <ul className="product-list">
              { items }
            </ul>
          </li>
        )
      })
    }

    return (
      <section className="offer-page">
      	<ul className="breadcrumbs">
      		<div className="container-big">
	      		<li><NavLink to="/">Strona główna</NavLink></li>
	      		<li><NavLink to="/oferta">Oferta</NavLink></li>
	      		{ this.props.match.params.name ? <li><NavLink to={ "/oferta/" + this.props.match.params.name }>{  }</NavLink></li> : null }
      		</div>
      		<div className="bottom"></div>
      	</ul>
        <div className="outer-container">
          <SideNav data={ this.props.data }/>
        	<div className="container">
        		{ selectedCategory ? <h1 dangerouslySetInnerHTML={{ __html: this.addColor(selectedCategory.title) }}></h1> : <h1 dangerouslySetInnerHTML={{ __html: this.addColor( page ? page.additional_fields.pageTitle : "" ) }}></h1> }
        		{ this.props.match.params.name ? <ul className="product-list">
        			{ products }
        		</ul> : <ul>
              { products }
            </ul> }
        		{ page ? <div className="bottom" dangerouslySetInnerHTML={{ __html: page.additional_fields.content }}></div> : null }
        	</div>
        </div>
      	<Footer data={ this.props.data } settings={ this.props.data.settings }/>
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/OfferPage.js